module.exports = __webpack_public_path__ + "img/20-WHEEL.c3ca3cfe.png";